<template>
  <v-app
    id="inspire"
  >

   <!-- slide out menu -->
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
      class="nav-drawer"
      id="scroll-style"
    >
    <div class="nav-container">

        <div class="logo-container">
          <div class="logo">
            <v-avatar
              tile="tile"
              size="125"
            >
              <img src="./assets/recall-find.png" alt="RecallFind logo">
            </v-avatar>
          </div>
        </div>

    <v-list class="nav-menu">
      <template>
          <v-list>
            <router-link :to="{ name: 'Home' }" tag='div' style='cursor: pointer'>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>home</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                    Home
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <v-list-group value="true" >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-action>
                    <img src="./assets/cpsc-logo.png" class="cpsc-logo" alt="Consumer Products Safety Commission logo">
                  </v-list-tile-action>
                  <v-list-tile-title>
                    Product Recalls by:
                  </v-list-tile-title>
                </v-list-tile>
              </template>

              <div class="calendar-list">
                <router-link :to="{ name: 'RecallList' }" tag='div' style='cursor: pointer'>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon>fa-calendar-week</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Month</v-list-tile-title>
                  </v-list-tile>
                </router-link>

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>fa-calendar-alt</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Year</v-list-tile-title>
                  <v-select
                    :items="years"
                    @input="itemChanged"
                    class="nav-year-list"
                    label="Select"
                    solo
                  ></v-select>
                </v-list-tile>
              </div>
            </v-list-group>

            <v-list-group
              prepend-icon="fa-user-shield"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>Other Agencies</v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-group
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-action>
                      <img src="./assets/fda-logo.png" class="fda-logo" alt="Food & Drug Administration logo">
                    </v-list-tile-action>
                    <v-list-tile-title>
                      <div class="agency-description fda">FDA</div>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>

                <div v-for="(item, i) in newsFeedsFDA" :key="i">
                  <router-link :to="{ name: 'RecallNews', params: { name: item.routeName }}" tag='div' style='cursor: pointer'>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile>
                  </router-link>
                </div>
              </v-list-group>

              <v-list-group
                sub-group
                no-action
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-action>
                      <img src="./assets/nhtsa-logo.png" class="nhtsa-logo" alt="National Highway Traffic Safety Administration logo">
                    </v-list-tile-action>
                    <v-list-tile-title>
                      <div class="agency-description nhtsa">NHTSA</div>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>

                <div v-for="(item, i) in newsFeedsNHTSA" :key="i">
                  <router-link :to="{ name: 'RecallNews', params: { name: item.routeName }}" tag='div' style='cursor: pointer'>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile>
                  </router-link>
                </div>
              </v-list-group>
            </v-list-group>

            <router-link :to="{ name: 'RecallFAQ' }" tag='div' style='cursor: pointer'>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>fa-question-circle</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                    Frequently Asked Questions
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <a href="https://www.saferproducts.gov/CPSRMSPublic/Incidents/ReportIncident.aspx" target="_blank" rel="noopener noreferrer">
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>fa-exclamation-triangle</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Report a Product</v-list-tile-title>
              </v-list-tile>
            </a>

            <router-link :to="{ name: 'Contact' }" tag='div' style='cursor: pointer'>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>fa-envelope</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  Contact Us
                </v-list-tile-title>
              </v-list-tile>
            </router-link>
          </v-list>
      </template>
    </v-list>

    </div>
  </v-navigation-drawer>

  <!-- top nav -->
  <v-toolbar app fixed class="top-nav">
    <v-toolbar-side-icon dark @click.stop="drawer = !drawer" ></v-toolbar-side-icon>
    <v-toolbar-title class="align-center toolbar-title">
        <router-link to='/' tag='div' style='cursor: pointer'>
          <div class="top-nav-logo">RecallFind</div>
        </router-link>
    </v-toolbar-title>
    <v-layout row justify-center>
      <v-flex xs12 sm6 md3>
        <v-text-field
          label="Search by Keyword"
          v-model="searchString"
          clearable
          dark
          color="#fff"
          class="search-input"
          @keyup.enter="enterSubmit"
          >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-btn
          flat
          dark
          :disabled="!dataAvailable"
          @click="searchRecalls"
          color="#fff"
          class="search-btn"
          aria-label="Search button"
        >
          <v-icon>fa-shield-alt</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-btn dark icon v-if="isList" @click.stop="listView()">
      <v-icon>apps</v-icon>
    </v-btn>
    <v-btn dark icon v-else @click.stop="listView()">
      <v-icon>view_list</v-icon>
    </v-btn>
  </v-toolbar>

  <!-- main content -->
    <v-content>
      <v-container fluid fill-height class="pa-0">
        <v-layout
          justify-center
        >
          <v-flex text-xs-center>
            <transition :name="transitionName" mode="out-in">
              <keep-alive>
                <router-view :key="$route.fullPath">
                </router-view>
              </keep-alive>
            </transition>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    fav: true,
    menu: true,
    message: false,
    hints: true,
    fixed: true,
    drawer: false,
    theme: false,
    isList: false,
    searchString: '',
    year: '',
    transitionName: '',

    newsFeedsFDA: [
      { icon: 'fa-briefcase-medical', title: 'FDA Recalls', routeName: 'FDARecalls' },
      { icon: 'fa-utensils', title: 'Food Safety', routeName: 'FoodSafety' },
      { icon: 'fa-allergies', title: 'Food Allergy', routeName: 'FoodAllergy' },
      { icon: 'fa-pills', title: 'Drug Recalls', routeName: 'DrugRecalls' },
      { icon: 'fa-prescription-bottle-alt', title: 'MedWatch', routeName: 'MedWatch' },
      { icon: 'fa-dog', title: 'PetHealth', routeName: 'PetHealth' }
    ],
    newsFeedsNHTSA: [
      { icon: 'fa-car', title: 'Vehicles', routeName: 'VehicleRecalls' },
      { icon: 'fa-truck-monster', title: 'Tires', routeName: 'TireRecalls' },
      { icon: 'fa-baby', title: 'Child Restraints', routeName: 'ChildRestraintRecalls' }
    ]
  }),
  methods: {
    listRecalls () {
      this.$router.push({ path: '/list/' + this.year })
    },
    enterSubmit () {
      this.searchRecalls()
    },
    searchRecalls () {
      this.$router.push('/search/' + this.searchString)
      this.searchString = ''
    },
    listView () {
      this.isList = !this.isList
      var eventName = 'emitListView'
      window.bus.$emit(eventName, {
        isList: this.isList
      })
    },
    itemChanged (item) {
      this.year = item
      this.listRecalls()
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    years () {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 1972 }, (value, index) => 1973 + index).reverse()
    },
    dataAvailable () {
      return this.searchString !== null && this.searchString !== ''
    }
  }
}
</script>

<style lang="stylus">
  .v-progress-circular
    margin: 1rem
</style>

<style lang="scss">
  $base-font-color: #242123;
  $base-font-color-lighter: rgba(36, 33, 35, .8);
  $font-family-alt: 'Lato', sans-serif;

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .theme--light {
    color: $base-font-color;

    .v-icon {
      color: $base-font-color;
    }

  }

  .v-progress-circular {
    color: #6B7AFE;
  }

  .top-nav {
    background-image: linear-gradient(-20deg, #b721ff 0%, #21d4fd 100%);
    color: #fff !important;

    .toolbar-title {
      margin: 0 1rem 0 0;
      overflow: visible;
    }

    .top-nav-logo {
      font-family: $font-family-alt;
    }
    .search-input {
      .v-icon {
        color: #fff;
      }
      .v-input__append-inner {
        display: none;
      }
    }
    .search-btn {
      min-width: auto;
      padding: 4px;
      margin-top: 10px;

      .search-container {
        display: flex;
      }
    }
  }

  .page-header {
      font-family: $font-family-alt;
      font-weight: 700;
      font-size: 1.625rem;
      line-height: 1.75rem;
      letter-spacing: .2em;
      text-transform: uppercase;
      margin-bottom: 18px;
      padding-top: 24px !important;
      padding-bottom: 0 !important;

      &:after {
        content: ' ';
        display: block;
        width: 300px;
        height: 10px;
        margin: 0 auto;
        border-bottom: 1px solid #ddd;
      }
  }

  .recall-container {
    padding-top: 0;

    .recall-month-header {
      @extend .page-header;
    }

    .recall-card {
      .title {
        color: $base-font-color;
      }
      .recall-description {
        font-family: $font-family-alt;
      }
      .recall-date {
        color: $base-font-color-lighter;
      }
    }
  }

  .social-icons {
    padding: 0;
  }

  .nav-drawer {
    background-color: #e7e7e7 !important;

    a {
      text-decoration: none;
    }

    .nav-container {
      display: flex;
      flex-direction: column;
      height: 100%;

      .logo-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 150px;
      }

      .nav-menu {
        flex: 1 auto;

        .cpsc-logo {
          width: 24px;
          height: 24px;
        }

        .calendar-list {
          padding-left: 30px;
        }

        .nav-year-list {
          .v-input__control {
            min-height: auto;

            .v-input__slot {
              padding: 0 8px;
              margin-bottom: 0;
            }

            .v-text-field__details {
              display: none;
            }
          }
        }

        .fda-logo {
          width: 24px;
          height: 24px;
        }

        .nhtsa-logo {
          width: 24px;
          height: 24px;
        }

        .agency-description {
          display: inline-block;
        }
      }

      .nav-footer-list {
        display: block;
        list-style-type: none;
        padding: 0;
        text-align: center;

        > li {
          display: inline-block;
          font-size: .875rem;
          margin: 0 10px 0 0;
          padding: 0 10px 0 0;
          border-right: 1px solid #d3d3d3;

          &:last-child {
            border-right: none;
          }
        }
      }
    }

  }

  #scroll-style::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
  }

  #scroll-style::-webkit-scrollbar-thumb {
    background-color: #b721ff;
    background-image: linear-gradient(-20deg, #b721ff 0%, #41AEFD 100%);
  }

  #scroll-style::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  </style>
